<div *ngIf="isLoading" class="d-flex spinner-container align-items-center justify-content-center">
  <div class="spinner-border text-dark" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  <span *ngIf="loadingText" class="loading-spinner__text">{{ loadingText }}</span>
</div>
